import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestOvertimesGetRes } from "./abst/DtoRequestOvertimesGetRes";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestOvertimesGetResImple extends DtoRequestOvertimesGetRes {
  public request = new EntityRequest();

  public pager = new DtoApiPager();
}
